import React from "react";
import { IForm, IStep } from "./type";
import { Space } from "@mantine/core";
import TermDepositStepOne from "./term-deposit-step-1/TermDepositStepOne";
import { UseFormReturnType } from "@mantine/form";
import TermDepositStepTwo from "./term-deposit-step-2/TermDepositStepTwo";
import TermDepositStepThree from "./term-deposit-step-3/TermDepositStepThree";
import { GetMoneySource } from "@/dto/bank/response/BankInfo";

interface ITermDepositContainerProps {
  step: IStep;
  form: UseFormReturnType<IForm>;
  onSubmitStepOne: () => void;
  onSubmitStepTwo: () => void;
  onSubmitStepThree: () => void;
  onBackStepOne?: () => void;
  isLoadingStepOne?: boolean;
  isLoadingStepTwo?: boolean;
  sources: GetMoneySource[];
  sourceLinkId: number;
  onChangeSourceLink: (sourceLinkId: number) => void;
}

const TermDepositContainer: React.FC<ITermDepositContainerProps> = ({
  step,
  form,
  onSubmitStepOne,
  onSubmitStepTwo,
  onSubmitStepThree,
  onBackStepOne,
  isLoadingStepOne,
  isLoadingStepTwo,
  sources,
  sourceLinkId,
  onChangeSourceLink,
}) => {
  return (
    <>
      <Space h={30} />
      {step === 1 && (
        <TermDepositStepOne
          onChangeSourceLink={onChangeSourceLink}
          sources={sources}
          sourceLinkId={sourceLinkId}
          form={form}
          onSubmit={onSubmitStepOne}
          isLoading={isLoadingStepOne}
        />
      )}
      {step === 2 && (
        <TermDepositStepTwo
          onSubmit={onSubmitStepTwo}
          onBackStepOne={onBackStepOne}
          form={form}
          isLoading={isLoadingStepTwo}
        />
      )}
      {step === 3 && (
        <TermDepositStepThree onSubmit={onSubmitStepThree} form={form} />
      )}
    </>
  );
};

export default TermDepositContainer;
